// src/routes/ProtectedRoute.jsx

import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, roles }) {

  const user = JSON.parse(localStorage.getItem("user"));

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (roles && !roles.includes(user.role)) {

    // non-admin users redirect to recordings
    if (user.role === "admin" || user.role === "agent" || user.role === "user") {
      return <Navigate to="/dashboard/ai-recordings" replace />;
    }

    return <Navigate to="/" replace />;
  }

  return children;
}